"use strict"; // export class AppConfiguration {
//     private static instance: AppConfiguration;
//     private _json: any;
//     private constructor() { }
//     static Setting() {
//         if (!AppConfiguration.instance) {
//             AppConfiguration.instance = new AppConfiguration();
//             AppConfiguration.instance._json = require('../../../appsettings.json');
//         }
//         return AppConfiguration.instance._json;
//     }
// }

var _classCallCheck = require("/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AppConfiguration =
/*#__PURE__*/
function () {
  function AppConfiguration() {
    _classCallCheck(this, AppConfiguration);
  }

  _createClass(AppConfiguration, null, [{
    key: "Setting",
    value: function Setting() {
      return this.json;
    }
  }]);

  return AppConfiguration;
}();

AppConfiguration.json = require('../../../appsettings.json');
exports.AppConfiguration = AppConfiguration;